import clsx from 'clsx';

interface Props extends BaseProps {
  classes?: {
    root?: string;
    primaryText?: string;
    secondaryText?: string;
  };
  className?: string;
  primary: string;
  secondary?: string;
}

export const ListItemText = ({
  classes,
  className,
  primary,
  secondary,
}: Props) => {
  const styles = useStyles();

  if (secondary !== undefined)
    return (
      <div className={clsx('flex flex-col', classes?.root, className)}>
        <span className={clsx(classes?.primaryText, styles.primaryText)}>
          {primary}
        </span>
        <span className={clsx(classes?.secondaryText, styles.secondaryText)}>
          {secondary}
        </span>
      </div>
    );
  return (
    <span className={clsx(classes?.primaryText, styles.primaryText)}>
      {primary}
    </span>
  );
};

const useStyles = () => ({
  primaryText: 'text-md',
  secondaryText: 'text-xs opacity-70',
});
